import * as T99FrontUtils from './utils/frontEndUtils';

import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
import ScrollTrigger from "gsap/ScrollTrigger";
import Lenis from 'lenis'

/**
 * Utilità varie front-end
 * 
 */
T99FrontUtils.columnLinkFront(); // Agginge link alle colonne
T99FrontUtils.browserDetection(); // Rilevamento del browser e dispositivo
T99FrontUtils.checkLoadEvents(); // Verifica gli eventi di caricamento
T99FrontUtils.scrollBody(); // Aggiunge la classe scroll al body

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis(); // oppure senza gsap => const lenis = new Lenis({autoRaf: true,});
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);



/**
 * 
 * THEME INIT
 * 
 * 
 */

document.addEventListener('DOMContentLoaded', () => {
  headerInit();
  footerInit();

  linkAlPostQuery();


  animationHeroAnimata(); // Hero animata
  animationElementiParallax(); // data-scroll
  animationGroupFadeIn(); // animation-comparsa
  animationSeparatori();
  animationListeConMarkers();
  animationFormProgetto();

  patternListaConImmagini();

});



function gestisciStatoLenis() {
  if (document.body.classList.contains('menu-open')) {
    if (!gestisciStatoLenis._stopped) {
      lenis.stop();
      gestisciStatoLenis._stopped = true;
      document.documentElement.style.overflow = 'hidden';
    }
  } else if (gestisciStatoLenis._stopped) {
    lenis.start();
    document.documentElement.style.overflow = '';
    gestisciStatoLenis._stopped = false;
  }
}

function linkAlPostQuery() {
  const queries = document.querySelectorAll('.wp-block-query');
  if (!queries.length) {
    return;
  }

  queries.forEach((query) => {
    const postItems = query.querySelectorAll('.wp-block-post');
    if (!postItems.length) {
      return;
    }
    postItems.forEach((postItem) => {
      const link = postItem.querySelector('a');
      const elementToLink = postItem.querySelector('[link-to-post]');
      if (link && elementToLink) {
        elementToLink.style.cursor = 'pointer';
        elementToLink.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = link.href;
        });
      }
    });

  });
}


function headerInit() {
  const menuItemsWithChildren = document.querySelectorAll('.menu-item.menu-item-has-children');
  const iconaHamburgers = document.querySelectorAll('.hamburger-container');
  const darker = document.querySelector('#overlay .darker');


  // HAMBURGER ICON TRIGGER
  if (iconaHamburgers.length) {
    iconaHamburgers.forEach(iconaHamburger => {
      iconaHamburger.addEventListener('click', (e) => {


        document.body.classList.toggle('menu-open');
        gestisciStatoLenis();
      });
    });
  }

  // CHIUSURA MENU AL CLICK SUL DARKER
  if (darker) {
    darker.addEventListener('click', (e) => {
      document.body.classList.remove('menu-open');
      gestisciStatoLenis();
      iconaHamburgers?.forEach(iconaHamburger => {
        iconaHamburger.querySelector('input').checked = false;
      });
    });
  }

  // APERTURA SUB MENU
  if (!menuItemsWithChildren.length) {
    return;
  }

  if (window.innerWidth > 781) {
    menuItemsWithChildren.forEach((menuItem) => {
      const trigger = menuItem.querySelector(':scope > a, :scope > button');
      const submenu = menuItem.querySelector(':scope > .sub-menu');

      if (!trigger) {
        return;
      }

      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');

      let closeTimeoutId = null;

      const clearCloseTimeout = () => {
        if (closeTimeoutId) {
          window.clearTimeout(closeTimeoutId);
          closeTimeoutId = null;
        }
      };

      const openSubmenu = () => {
        clearCloseTimeout();
        menuItem.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      };

      const closeSubmenu = () => {
        clearCloseTimeout();
        menuItem.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      };

      const scheduleClose = () => {
        clearCloseTimeout();
        closeTimeoutId = window.setTimeout(closeSubmenu, 200);
      };

      menuItem.addEventListener('mouseenter', openSubmenu);
      menuItem.addEventListener('mouseleave', scheduleClose);
      menuItem.addEventListener('focusin', openSubmenu);
      menuItem.addEventListener('focusout', (event) => {
        const relatedTarget = event.relatedTarget;

        if (!relatedTarget || !menuItem.contains(relatedTarget)) {
          closeSubmenu();
        }
      });

      if (submenu) {
        submenu.addEventListener('mouseenter', openSubmenu);
        submenu.addEventListener('mouseleave', scheduleClose);
      }
    });
  }
  else {
    menuItemsWithChildren.forEach((menuItem) => {
      const trigger = menuItem.querySelector(':scope > a, :scope > button');
      const submenu = menuItem.querySelector(':scope > .sub-menu');

      if (!trigger || !submenu) {
        return;
      }

      // Setup ARIA
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');

      trigger.addEventListener('click', (e) => {
        // Prevent navigation; toggle submenu visibility
        e.preventDefault();
        e.stopPropagation();

        const nowOpen = submenu.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      });
    });

    // Close all open submenus when overlay darker is clicked
    if (darker) {
      darker.addEventListener('click', () => {
        document.querySelectorAll('.sub-menu.is-open').forEach((sm) => sm.classList.remove('is-open'));
        document.querySelectorAll('.menu-item.menu-item-has-children > a, .menu-item.menu-item-has-children > button')
          .forEach((trg) => trg.setAttribute('aria-expanded', 'false'));
      });
    }
  }
}

function footerInit() {
  const scrollTopBtn = document.getElementById('SCROLL-TO-TOP');
  if (!scrollTopBtn) {
    return;
  }

  scrollTopBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (!lenis) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    } else {
      lenis.scrollTo(0, { duration: 1.5, });
    }

  });
}


function patternListaConImmagini() {
  const patternList = document.getElementById('pattern__lista-con-immagini');
  if (!patternList) {
    return;
  }

  const rows = patternList.querySelectorAll('.single-line');
  const images = patternList.querySelectorAll('.image figure');

  if (!rows.length || !images.length) {
    return;
  }

  let activeImage = null;
  let setXOffset = null;
  const MAX_PARALLAX_X = 100;

  const hideActiveImage = () => {
    if (!activeImage) return;
    gsap.to(activeImage, { autoAlpha: 0, duration: 0.25, ease: 'power1.in' });
    activeImage = null;
  };

  rows.forEach((row) => {
    const image = row.querySelector('.image figure');
    if (!image) return;

    const showImage = () => {
      const prevX = activeImage && activeImage !== image ? gsap.getProperty(activeImage, 'x') : 0;

      if (activeImage && activeImage !== image) {
        gsap.to(activeImage, { autoAlpha: 0, duration: 0.2, ease: 'power1.out', overwrite: 'auto' });
      }

      activeImage = image;

      gsap.set(image, { x: prevX || 0 });
      setXOffset = gsap.quickTo(image, 'x', { duration: 0.3, ease: 'power3.out', overwrite: 'auto' });

      gsap.to(image, { autoAlpha: 1, duration: 0.25, ease: 'power1.out', overwrite: 'auto' });
    };

    row.addEventListener('mouseenter', showImage);
    row.addEventListener('focusin', showImage);
  });

  const firstRow = rows[0];
  if (firstRow) {
    const firstImage = firstRow.querySelector('.image figure');
    if (firstImage) {
      activeImage = firstImage;
      gsap.set(firstImage, { autoAlpha: 1, x: 0 });
      setXOffset = gsap.quickTo(firstImage, 'x', { duration: 0.3, ease: 'power3.out', overwrite: 'auto' });
    }
  }

  patternList.addEventListener('mouseleave', hideActiveImage);
  patternList.addEventListener('focusout', (event) => {
    const relatedTarget = event.relatedTarget;
    if (!relatedTarget || !patternList.contains(relatedTarget)) {
      hideActiveImage();
    }
  });

  const handleParallax = (e) => {
    if (!activeImage || !setXOffset) return;
    const rect = patternList.getBoundingClientRect();
    const nx = ((e.clientX - rect.left) / rect.width) - 0.5;
    const offX = gsap.utils.clamp(-MAX_PARALLAX_X, MAX_PARALLAX_X, nx * 2 * MAX_PARALLAX_X);
    setXOffset(offX);
  };
  patternList.addEventListener('mousemove', handleParallax);

}


function animationHeroAnimata() {
  const heroAnimata = document.querySelector('.wp-block-cover.is-style-hero-animated');

  // Check if heroAnimata is the first block in the content
  if (!heroAnimata || heroAnimata !== document.querySelector('.entry-content > .wp-block-cover.is-style-hero-animated')) {
    return;
  }


  let tl = gsap.timeline();
  let mySplitText;
  let lines;

  const firstElementsPagina = gsap.utils.toArray(
    ".wp-block-post-title, p, .wp-block-button, .wp-block-heading",
    heroAnimata
  );

  document.fonts.ready.then(() => {

    (mySplitText = new SplitText(firstElementsPagina, { type: "lines" })),
      (lines = mySplitText.lines);

    tl.from(lines, {
      duration: 1,
      delay: 0.2,
      opacity: 0,
      y: 50,
      ease: "power4.out",
      stagger: index => 0.2 + index * 0.2,
    });

  })

  const bg = heroAnimata.querySelector('.wp-block-cover__video-background, .wp-block-cover__image-background');
  const content = heroAnimata.querySelector('.wp-block-cover__inner-container');
  const overlay = heroAnimata.querySelector('.wp-block-cover__background');

  if (!bg || !content || !overlay) {
    return;
  }

  gsap.set(heroAnimata, { minHeight: '100svh', height: '100svh' });
  gsap.set(bg, { height: '100svh', width: '100vw', objectFit: 'cover', position: 'fixed', top: 0, left: 0, zIndex: -1 });
  gsap.set(overlay, { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100svh' });
  gsap.set(content, { position: 'relative', zIndex: 1 });

  gsap.to(content, {
    scrollTrigger: {
      trigger: heroAnimata,
      start: 'bottom 40%',
      markers: false,
      scrub: false,
      toggleActions: "play reverse play reverse",
    },
    opacity: 0,
    ease: "power1.out",
  });

  gsap.to(content, {
    y: (i, el) =>
      (0.9 *
        ScrollTrigger.maxScroll(window)) /
      2,
    ease: "none",
    scrollTrigger: {
      start: 0,
      end: "max",
      invalidateOnRefresh: true,
      scrub: 0,
    },
  });

  // gsap.to(overlay, {
  //   scrollTrigger: {
  //     trigger: heroAnimata,
  //     start: 'bottom 35%',
  //     duration: 0.8,
  //     toggleActions: "play reverse play reverse",
  //   },
  //   backgroundColor: "#f2f2f2",
  //   opacity: .6,
  //   ease: "power2.out",
  // });



}


function animationElementiParallax() {
  if (window.innerWidth < 781) return;

  const elements = gsap.utils.toArray("[data-scroll]");

  elements.forEach((el) => {
    const speed = parseFloat(el.getAttribute("data-scroll")) || 1;

    gsap.to(el, {
      yPercent: -(1 - speed) * 50 * (speed > 1 ? 1 : -1),
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "bottom top",
        ease: "none",
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  });
}

function animationGroupFadeIn() {
  const groups = gsap.utils.toArray(".animation-comparsa");
  if (!groups.length) return;

  groups.forEach((group) => {
    const items = group.querySelectorAll(".wp-block-cover");
    if (!items.length) return;

    gsap.set(items, { autoAlpha: 0, y: 50 });

    const st = ScrollTrigger.create({
      trigger: group,
      start: "top 80%",
      end: "bottom 20%",
      markers: false,
      onEnter: () => {
        gsap.to(items, {
          autoAlpha: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
          stagger: 0.2,
          overwrite: 'auto',
        });
      }
    });
  });
}

function animationSeparatori() {
  const seps = gsap.utils.toArray(".wp-block-separator.is-style-full-width, .wp-block-separator.full-width, .wp-block-separator.alignfull ");

  if (!seps.length) return;

  seps.forEach((sep) => {
    gsap.set(sep, { scaleX: 0, opacity: 0, transformOrigin: 'center center' });

    const st = ScrollTrigger.create({
      trigger: sep,
      start: "top 90%",
      end: "bottom 10%",
      markers: false,
      onEnter: () => {
        gsap.to(sep, {
          opacity: 1,
          scaleX: 1,
          duration: 1.4,
          ease: "power2.out",
          overwrite: 'auto',
        });
      }
    });
  });
}


function animationListeConMarkers() {
  const lists = gsap.utils.toArray(".wp-block-list.is-style-mark-icons");

  if (!lists.length) return;

  lists.forEach((list) => {
    const items = list.querySelectorAll("li");
    if (!items.length) return;

    gsap.set(items, { autoAlpha: 0, x: -30 });

    const st = ScrollTrigger.create({
      trigger: list,
      start: "top 80%",
      end: "bottom 20%",
      markers: false,
      onEnter: () => {
        gsap.to(items, {
          autoAlpha: 1,
          x: 0,
          duration: 0.6,
          ease: "power2.out",
          stagger: 0.2,
          overwrite: 'auto',
        });
      }
    });
  });
}

function animationFormProgetto() {
  const formContent = document.querySelector('.form-progetto-da-realizzare');

  if (!formContent) return;


  gsap.from(formContent, {
    scrollTrigger: {
      trigger: formContent,
      start: "top 80%",
      markers: false,
    },
    autoAlpha: 0,
    y: 70,
    duration: 1.2,
    ease: "power1.out",
    overwrite: 'auto',
  });

}

